import common from "./common";
import auth from "./auth";
import app from "./app";
import billing from "./billing";
import landing from "./landing";

const translations = {
    ...common,
    ...auth,
    ...app,
    ...billing,
    ...landing
}

export default translations
